import React, { MouseEvent, useCallback } from "react";
import * as styles from "./MenuSection.module.scss";
import { MainMenuSectionFragment } from "types/graphql-types";
import { isPresent } from "src/utils/checks";
import { toValidatedMainMenuGroup } from "../utils";
import { Icon } from "@silversea-ssc/ui-components-react";
import MainMenuPanel from "../MainMenuPanel/MainMenuPanel";
import MenuSectionItem from "./MenuSectionItem";
import clsx from "clsx";

type Props = {
  item: MainMenuSectionFragment;
  isMenuOpen: boolean;
};

export const MenuSection: React.FC<Props> = ({ item, isMenuOpen }) => {
  const [isExpanded, setIsExpanded] = React.useState(false);

  const onClickExpand = useCallback((e: MouseEvent) => {
    e.preventDefault();
    setIsExpanded(true);
    return false;
  }, []);
  const onClickBack = useCallback(() => {
    setIsExpanded(false);
  }, []);

  if (!isPresent(item)) return null;
  const groups = item.items?.filter(isPresent) || [];
  const validatedItems = groups.map(toValidatedMainMenuGroup);

  return (
    <MenuSectionItem role="none">
      <MainMenuPanel
        isExpanded={isMenuOpen && isExpanded}
        items={validatedItems}
        onClickBack={onClickBack}
        title={item.title?.localized || ""}
        href={item.page?.fullPath}
        trackingName={item.trackingName}
        className={styles.sectionGroups}
        trendingNow={item.trendingNow}
        id={item._key || ""}
      />

      <a
        href={item.page?.fullPath}
        className={clsx(styles.button, styles.desktopOnly)}
        role="menuitem"
        aria-haspopup="true"
        aria-expanded="false"
        data-content-piece={item.trackingName}
      >
        {item.title?.localized}{" "}
        <Icon
          className={styles.chevronIcon}
          size="1.5x"
          name="chevron-right"
          padding={false}
        />
      </a>

      <button
        className={clsx(styles.button, styles.mobileOnly)}
        role="menuitem"
        aria-haspopup="true"
        aria-expanded="false"
        onClick={onClickExpand}
        data-content-piece={item.trackingName}
      >
        {item.title?.localized}{" "}
        <Icon
          className={styles.chevronIcon}
          size="1.5x"
          name="chevron-right"
          padding={false}
        />
      </button>
    </MenuSectionItem>
  );
};
